import API from "../core/api";
import { getGuestAuthSettings } from "../core/utils";
import { createResource, fetchResource } from "../resources/actions";
import isEmpty from "lodash/isEmpty";

const resourceFulfilled = (model, data, params) => ({
  meta: {
    model,
    params: params || {},
    time: Date.now(),
  },
  payload: data,
  type: "FETCH_RESOURCE_FULFILLED",
});

export const loadSiteData = (siteData) => (dispatch) => {
  // When the data arrives from the API sections are nested within pages. The
  // resource system depends on sections being their own resource so we
  // extract them here.
  const sections = [];

  if (siteData.pages) {
    siteData.pages
      .filter((page) => !isEmpty(page.sections))
      .forEach((page) => {
        sections.push([page.id, page.sections]);
        page.sections = page.sections.map(({ id }) => id);
      });
  }
  const actions = Object.entries(siteData)
    .filter(([, value]) => !isEmpty(value))
    .map(([key, value]) => dispatch(resourceFulfilled(key, value)));

  sections.forEach(([page, data]) => {
    actions.push(
      dispatch(
        resourceFulfilled("sections", data, {
          page,
        }),
      ),
    );
  });

  return Promise.all(actions);
};

export const createComment = (comment) => (dispatch) => {
  // If the promise exists, we need to wait for it, so .all will have either 0 or 1 promises.
  return dispatch(
    createResource("comments", comment, getGuestAuthSettings()),
  ).then(() =>
    dispatch(
      fetchResource("comments", "/comments", {}, getGuestAuthSettings()),
    ),
  );
};

export const deleteComment = (id) => (dispatch) =>
  API.delete(`comments/${id}/`, {}).then(() => {
    dispatch(fetchResource("comments", "/comments"));
  });
